import $ from 'jquery';
window.$ = window.jQuery = $;

import '../css/project.css';
import 'flowbite';
